import { SPP_BRAND, type SppScope } from './liveDataAdapter';

/** Recent launches exposes country, chain and margin controls, never overview channel/property controls. */
export function recentLaunchesSppScope(scope: SppScope): SppScope {
  return {
    ...scope,
    channel: 'all',
    detail: 'all',
    property: 'all',
    action: null,
    eligibleOnly: false,
    brand: SPP_BRAND,
  };
}

/** Worst performers exposes only country and its impressions range for SPP. */
export function worstPerformersSppScope(scope: SppScope): SppScope {
  return {
    ...scope,
    channel: 'all',
    detail: 'all',
    chain: 'all',
    property: 'all',
    margin: 'Exclude',
    action: null,
    eligibleOnly: false,
    brand: SPP_BRAND,
  };
}
